import { createFileRoute } from '@tanstack/react-router';
import { RomaneioListagemPage } from '@/features/romaneio/page/listagem/RomaneioListagemPage';

export const Route = createFileRoute('/a/romaneio/')({
    component: RomaneioListagemPage,
});
